import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { JurisdictionsService } from '../../../../services/api/general-settings/jurisdictions.service';
import { JurisdictionFormComponent } from '../components/jurisdiction-form/jurisdiction-form.component';

@Component({
  selector: 'app-jurisdiction-edit-page',
  imports: [JurisdictionFormComponent],
  templateUrl: './jurisdiction-edit-page.component.html',
  styleUrl: './jurisdiction-edit-page.component.scss'
})
export class JurisdictionEditPageComponent {
  jurisdictionId!: number
  jurisdiction?: any;

  constructor(
    private route: ActivatedRoute,
    private jurisdictionsService: JurisdictionsService,
  ) {
  }

  ngOnInit(): void {
    this.jurisdictionId = Number(this.route.snapshot.paramMap.get('jurisdictionId'));
    if (this.jurisdictionId) {
      this.loadData(this.jurisdictionId);
    }
  }

  loadData(jurisdictionId: any) {
    this.jurisdictionsService.detail(jurisdictionId).subscribe((response: any) => {      
      this.jurisdiction = response.data?.jurisdiction;
    });

  }
   onJurisdictionFormSavedData(savedDataInfo: SavedDataInfo){
      if(savedDataInfo.success)
      {
        this.loadData(savedDataInfo.response?.data?.user?.userId);
      }
    }
}
